const placaValue = value => (/(([A-Za-z]{3})([0-9])([\w])([0-9]{2}))/g.test(value.replace('-', '')) ? value.replace(/(?=(\w{4})$)/g, '-') : value);

export default placaValue;
